import(/* webpackMode: "eager" */ "/home/runner/work/examanet/examanet/src/app/[locale]/inscription/page.tsx");
